import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Service } from '@angular/core';
import {
  BreakpointExtraSmall,
  BreakpointMedium,
  BreakpointSmall,
  BreakpointLarge,
} from '@thiememeulenhoff/tokens/core';
import { map } from 'rxjs';

@Service()
export class LayoutService {
  #observer = inject(BreakpointObserver);

  readonly isExtraSmallMobile$ = this.#observer
    .observe([`(max-width: ${BreakpointExtraSmall})`])
    .pipe(map((state) => state.matches));

  readonly isMobile$ = this.#observer
    .observe([`(max-width: ${BreakpointSmall})`])
    .pipe(map((state) => state.matches));

  static isMobile() {
    return window.innerWidth <= parseInt(BreakpointSmall, 10);
  }

  readonly isTablet$ = this.#observer
    .observe([`(max-width: ${BreakpointMedium})`])
    .pipe(map((state) => state.matches));

  static isTablet() {
    return window.innerWidth <= parseInt(BreakpointMedium, 10);
  }

  readonly isDesktop$ = this.#observer
    .observe([`(min-width: ${BreakpointMedium})`])
    .pipe(map((state) => state.matches));

  static isDesktop() {
    return window.innerWidth > parseInt(BreakpointMedium, 10);
  }

  readonly isDesktopLarge$ = this.#observer
    .observe([`(min-width: ${BreakpointLarge})`])
    .pipe(map((state) => state.matches));

  static isDesktopLarge() {
    return window.innerWidth > parseInt(BreakpointLarge, 10);
  }

  readonly isSmallerThan$ = (breakpoint: string) => {
    return this.#observer
      .observe([`(max-width: ${breakpoint})`])
      .pipe(map((state) => state.matches));
  };

  static isSmallerThan(breakpoint: string) {
    return window.innerWidth <= parseInt(breakpoint, 10);
  }
}
